/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { validateCardRequestRequestSchema } from "./validateCardRequestRequestSchema.ts";
import { validateCardResponseSchema } from "./validateCardResponseSchema.ts";

export const userValidateCardCreateStatus200Schema = validateCardResponseSchema.describe("Сериализатор для успешного ответа валидации карты.");

export const userValidateCardCreateStatus404Schema = errorResponseSchema;

export const userValidateCardCreateStatus503Schema = errorResponseSchema;

export const userValidateCardCreateResponseSchema = z.union([
	userValidateCardCreateStatus200Schema,
	userValidateCardCreateStatus404Schema,
	userValidateCardCreateStatus503Schema,
]);

export const userValidateCardCreateDataSchemaJson = validateCardRequestRequestSchema.describe("Сериализатор для валидации номера карты лояльности.");

export const userValidateCardCreateDataSchemaXml = validateCardRequestRequestSchema.describe("Сериализатор для валидации номера карты лояльности.");

export const userValidateCardCreateDataSchema = z.union([userValidateCardCreateDataSchemaJson, userValidateCardCreateDataSchemaXml]);
